import styles from "../../styles/components/searchFigma/ResultListItem.module.css";
import { logoUrl, periodFigma, periodNoDiv } from "../../components/search";
import GotoFigma from "../../components/gotoFigma";
import Goto from "../../components/gotoFigmaMobile";
export default function ResultListItem({
  parts,
  lifecycle,
  capitalize,
  isLogin,
  keyword,
  member,
}) {
  return (
    <div className={styles.frame02}>
      {parts.map((part, index) => (
        <div key={index} className={styles.frame020}>
          {/* 여기부터는 Figma 구조 유지 */}
          <div className={styles.group0200}>
            <div className={styles.frame0200}>
              <div className={styles.frame02000}>
                {/* ✅ 이미지 */}
                {part.image_origin ? (
                  // ✅ 실제 이미지가 있는 경우
                  <img
                    src={part.image_origin}
                    alt={part.name || "image"}
                    className={styles.image}
                    onError={(e) => {
                      e.target.src = "/images/noimageKO.jpg";
                    }}
                  />
                ) : (
                  // 🚫 이미지가 없는 경우 (no_image)
                  <img
                    src="/images/noimageKO.jpg"
                    alt="이미지 준비중"
                    className={styles.image}
                  />
                )}

                <div className={styles.frame020000}>
                  {/* ✅ 제조사 */}
                  <div className={styles.manufacturer}>
                    {part.manufacturername_str}
                  </div>

                  {/* ✅ 제품명 */}
                  <div className={styles.frame0200000}>
                    <div className={`${styles.productName} headline1`}>
                      {part.pn}
                    </div>
                    <div className={`${styles.productNameTablet} headline1`}>
                      {part.pn}
                    </div>
                    <div className={styles.line5}></div>
                    <img
                      src={lifecycle(part.LC)}
                      className={styles.rectangle29}
                    ></img>
                  </div>

                  {/* ✅ 요약 설명 */}
                  <div className={`${styles.summary} caption2`}>
                    {capitalize(part.description)}
                  </div>
                </div>
              </div>

              {/* ✅ 데이터시트 버튼 */}
              <div className={styles.frame02001}>
                {part.datasheet ? (
                  <>
                    <a
                      href={part.datasheet}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div
                        className={`${styles.buttonFillWhite} ${styles.cursorActive}`}
                      >
                        <div className={styles.iconDownloadFile}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM9.85375 10.3538L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L6.14625 10.3538C6.05243 10.2599 5.99972 10.1327 5.99972 10C5.99972 9.86732 6.05243 9.74007 6.14625 9.64625C6.24007 9.55243 6.36732 9.49972 6.5 9.49972C6.63268 9.49972 6.75993 9.55243 6.85375 9.64625L7.5 10.2931V7.5C7.5 7.36739 7.55268 7.24021 7.64645 7.14645C7.74021 7.05268 7.86739 7 8 7C8.13261 7 8.25979 7.05268 8.35355 7.14645C8.44732 7.24021 8.5 7.36739 8.5 7.5V10.2931L9.14625 9.64625C9.24007 9.55243 9.36732 9.49972 9.5 9.49972C9.63268 9.49972 9.75993 9.55243 9.85375 9.64625C9.94757 9.74007 10.0003 9.86732 10.0003 10C10.0003 10.1327 9.94757 10.2599 9.85375 10.3538ZM9.5 5.5V2.75L12.25 5.5H9.5Z"
                              fill="currentColor" /* 회색으로 */
                            />
                          </svg>
                        </div>

                        <div className={`${styles.datasheet} body3`}>
                          데이터시트
                        </div>
                      </div>
                    </a>
                  </>
                ) : (
                  <div className={styles.buttonFillWhite}>
                    <div
                      className={`${styles.iconDownloadFile} ${styles.datasheetDisable}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM9.85375 10.3538L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L6.14625 10.3538C6.05243 10.2599 5.99972 10.1327 5.99972 10C5.99972 9.86732 6.05243 9.74007 6.14625 9.64625C6.24007 9.55243 6.36732 9.49972 6.5 9.49972C6.63268 9.49972 6.75993 9.55243 6.85375 9.64625L7.5 10.2931V7.5C7.5 7.36739 7.55268 7.24021 7.64645 7.14645C7.74021 7.05268 7.86739 7 8 7C8.13261 7 8.25979 7.05268 8.35355 7.14645C8.44732 7.24021 8.5 7.36739 8.5 7.5V10.2931L9.14625 9.64625C9.24007 9.55243 9.36732 9.49972 9.5 9.49972C9.63268 9.49972 9.75993 9.55243 9.85375 9.64625C9.94757 9.74007 10.0003 9.86732 10.0003 10C10.0003 10.1327 9.94757 10.2599 9.85375 10.3538ZM9.5 5.5V2.75L12.25 5.5H9.5Z"
                          fill="currentColor" /* 회색으로 */
                        />
                      </svg>
                    </div>

                    <div className={`${styles.datasheetDisable} body3`}>
                      데이터시트
                    </div>
                  </div>
                )}
                <div className={styles.frame020010}>
                  <div className={`${styles.caption1} caption1`}>
                    {capitalize(part.source)}
                  </div>
                  <div className={`${styles.caption2} caption2`}>
                    | 컨텐츠 제공
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.product}>
            {/* 💡 part.price 배열 반복 */}
            {part.price.map((priceItem, idx) => (
              <div key={idx} className={styles.productDetail}>
                <div className={styles.productDetailCountGroup}>
                  {logoUrl(priceItem) ===
                  "/images/brand/search/arrow_logo.png" ? (
                    <img
                      src={logoUrl(priceItem)}
                      className={styles.distributorIconArrow}
                    />
                  ) : logoUrl(priceItem) ===
                    "/images/brand/search/digikey_logo.png" ? (
                    <img
                      src={logoUrl(priceItem)}
                      className={styles.distributorIconDigikey}
                    />
                  ) : (
                    <img
                      src={logoUrl(priceItem)}
                      className={styles.distributorIcon}
                    />
                  )}

                  <div className={styles.stockBox}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M17.475 5.16798L10.6 1.40626C10.4163 1.30477 10.2099 1.25153 10 1.25153C9.79013 1.25153 9.58369 1.30477 9.4 1.40626L2.525 5.16954C2.32866 5.27697 2.16477 5.43514 2.05043 5.62753C1.93609 5.81993 1.87551 6.03949 1.875 6.26329V13.7352C1.87551 13.959 1.93609 14.1785 2.05043 14.3709C2.16477 14.5633 2.32866 14.7215 2.525 14.8289L9.4 18.5922C9.58369 18.6937 9.79013 18.7469 10 18.7469C10.2099 18.7469 10.4163 18.6937 10.6 18.5922L17.475 14.8289C17.6713 14.7215 17.8352 14.5633 17.9496 14.3709C18.0639 14.1785 18.1245 13.959 18.125 13.7352V6.26408C18.1249 6.03987 18.0645 5.81982 17.9502 5.62698C17.8358 5.43414 17.6717 5.2756 17.475 5.16798ZM10 9.37501L3.72266 5.93751L10 2.50001L16.2773 5.93751L10 9.37501ZM10.625 17.1594V10.4555L16.875 7.03517V13.7352L10.625 17.1594Z"
                        fill="#FD9195"
                      />
                    </svg>
                    <div className={styles.stockCount}>
                      {/* ✅ price 데이터 표시 */}
                      <div className={`${styles.headLine} headline3`}>
                        {priceItem.stock.toLocaleString() || 0}
                      </div>
                      <div className={`${styles.subtle} caption2`}>개</div>
                    </div>
                  </div>

                  <div className={styles.moqBox}>
                    <div className={`${styles.captionMoq} caption1`}>MOQ</div>
                    <div className={styles.moqCount}>
                      <div className={`${styles.basic} caption2`}>
                        {priceItem.moq.toLocaleString() || 0}
                      </div>
                      <div className={`${styles.basic} caption2`}>개</div>
                    </div>
                  </div>
                </div>

                <div className={styles.productDetailPriceDeliveryGroup}>
                  <div className={styles.price}>
                    <div className={styles.searchThReBoReRiLeFi_Price}>
                      <div
                        className={`${styles.headline1} ${
                          priceItem.price > 0 ? "headline3" : "body1"
                        }`}
                      >
                        {priceItem.price > 0
                          ? member > 1 || isLogin == 0
                            ? // 상시할인이 들어가는 회원은 회원혜택가 노출
                              // 상시할인이 들어가지 않으면 회원은 일반회원가 노출맞
                              `${priceItem.hook_price.toLocaleString()}`
                            : `${priceItem.price.toLocaleString()}`
                          : "맞춤단가"}
                      </div>
                      <div
                        className={`${styles.subtle} ${
                          priceItem.price ? "caption1" : "body1"
                        }`}
                      >
                        {priceItem.price > 0
                          ? member > 1 || isLogin == 0
                            ? // 상시할인이 들어가는 회원은 회원혜택가 노출
                              // 상시할인이 들어가지 않으면 회원은 일반회원가 노출
                              `원`
                            : `원`
                          : ""}
                      </div>
                    </div>
                    {priceItem.source === "partner" ? (
                      <div className={styles.benefitGroup}>
                        <div className={styles.specialPrice}>
                          <div className={`${styles.label2} label2`}>
                            특가제공
                          </div>
                        </div>
                      </div>
                    ) : // 상시할인이 들어가는 회원은 회원혜택가 노출
                    member > 1 || isLogin == 0 ? (
                      <div className={styles.benefitGroup}>
                        <div className={styles.memberPrice}>
                          <div className={`${styles.label2} label2`}>
                            회원혜택가
                          </div>
                        </div>
                      </div>
                    ) : (
                      // 상시할인이 들어가지 않으면 회원(일반회원,비회원)은 일반회원가 노출
                      <div className={styles.benefitGroup}>
                        <div className={styles.normalPrice}>
                          <div className={`${styles.label2} label2`}>
                            일반회원가
                          </div>
                        </div>
                      </div>
                    )}

                    {priceItem.price > 0 ? (
                      <div className={styles.questionWrap}>
                        <div className={styles.question}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96452 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7662 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"
                              fill="#B6BCC9"
                            />
                            <path
                              d="M11.248 17V16.9932C11.248 16.579 11.5839 16.2432 11.998 16.2432C12.4123 16.2432 12.748 16.579 12.748 16.9932V17C12.748 17.4142 12.4123 17.75 11.998 17.75C11.5839 17.7499 11.248 17.4142 11.248 17ZM8.25 9.1416C8.25 8.31992 8.65081 7.57086 9.29395 7.0459C9.93281 6.52447 10.7722 6.25008 11.623 6.25H12.373C13.2238 6.25001 14.0632 6.52448 14.7021 7.0459C15.3336 7.56133 15.7309 8.29257 15.7451 9.09668L15.749 9.33398C15.7349 9.88659 15.5565 10.4236 15.2363 10.8809C14.8834 11.3849 14.3774 11.7622 13.7959 11.9707C13.5155 12.0981 13.2392 12.3545 13.0361 12.7412C12.8316 13.131 12.725 13.6106 12.7471 14.1045C12.7655 14.5182 12.445 14.8682 12.0312 14.8867C11.6176 14.905 11.2675 14.5846 11.249 14.1709C11.216 13.4292 11.3722 12.6838 11.708 12.0439C12.044 11.404 12.5547 10.882 13.1914 10.5977C13.2134 10.5878 13.2359 10.579 13.2588 10.5713C13.571 10.4667 13.8324 10.271 14.0078 10.0205C14.1828 9.77055 14.2654 9.47727 14.248 9.18555C14.2472 9.17091 14.2461 9.15627 14.2461 9.1416C14.2461 8.82744 14.0947 8.48621 13.7539 8.20801C13.4089 7.92638 12.9135 7.75001 12.373 7.75H11.623C11.0826 7.75008 10.5872 7.92641 10.2422 8.20801C9.90148 8.48618 9.75 8.82749 9.75 9.1416C9.74985 9.55569 9.41412 9.8916 9 9.8916C8.58588 9.8916 8.25015 9.55569 8.25 9.1416Z"
                              fill="#B6BCC9"
                            />
                          </svg>
                        </div>

                        <div className={styles.questionNotice}>
                          <div className={styles.qustionBallon}>
                            {member > 1 || isLogin == 0 ? (
                              <>
                                <span
                                  className={`${styles.highlight} caption1`}
                                >
                                  일반회원가
                                </span>
                                <span
                                  className={`${styles.highlight} caption2`}
                                >
                                  보다&nbsp;
                                </span>
                                <span
                                  className={`${styles.priceBlue} caption2`}
                                >
                                  {(
                                    priceItem.price - priceItem.hook_price
                                  ).toLocaleString()}
                                  원&nbsp;
                                </span>{" "}
                                <span
                                  className={`${styles.highlight} caption2`}
                                >
                                  더 할인되었습니다.
                                </span>
                              </>
                            ) : (
                              <>
                                <span
                                  className={`${styles.highlight} caption1`}
                                >
                                  회원혜택가&nbsp;
                                </span>
                                <span
                                  className={`${styles.highlight} caption2`}
                                >
                                  적용 시&nbsp;
                                </span>
                                <span className={`${styles.priceRed} caption2`}>
                                  {(
                                    priceItem.price - priceItem.hook_price
                                  ).toLocaleString()}
                                  원&nbsp;
                                </span>{" "}
                                <span
                                  className={`${styles.highlight} caption2`}
                                >
                                  더 할인됩니다.
                                </span>
                              </>
                            )}
                          </div>

                          <div className={styles.polygon}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="10"
                              viewBox="0 0 13 10"
                              fill="none"
                            >
                              <path
                                d="M5.19615 9C5.58105 9.66667 6.5433 9.66667 6.9282 9L12.1244 0H0L5.19615 9Z"
                                fill="#F8FAFB"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={styles.questionWrap}>
                        <div className={styles.question}></div>
                      </div>
                    )}
                  </div>

                  <div className={styles.deliveryButtonGroup}>
                    <div className={styles.deliveryBox}>
                      <div className={styles.pack}>
                        <div className={`${styles.caption2Pack} caption2`}>
                          PACK |
                        </div>
                        <div className={styles.body2}>
                          {priceItem.packaging || "-"}
                        </div>
                      </div>
                      <div className={styles.deliveryDate}>
                        <div className={styles.labelDelivery}>
                          {priceItem.location === "국내" ? (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M23.1966 10.2188L21.8841 6.9375C21.7727 6.65973 21.5804 6.42184 21.3321 6.25467C21.0839 6.08751 20.7912 5.99878 20.4919 6H17.25V5.25C17.25 5.05109 17.171 4.86032 17.0303 4.71967C16.8897 4.57902 16.6989 4.5 16.5 4.5H2.25C1.85218 4.5 1.47064 4.65804 1.18934 4.93934C0.908035 5.22064 0.75 5.60218 0.75 6V16.5C0.75 16.8978 0.908035 17.2794 1.18934 17.5607C1.47064 17.842 1.85218 18 2.25 18H3.84375C4.00898 18.6453 4.38428 19.2173 4.91048 19.6257C5.43669 20.0342 6.08387 20.2559 6.75 20.2559C7.41613 20.2559 8.06331 20.0342 8.58952 19.6257C9.11572 19.2173 9.49102 18.6453 9.65625 18H14.3438C14.509 18.6453 14.8843 19.2173 15.4105 19.6257C15.9367 20.0342 16.5839 20.2559 17.25 20.2559C17.9161 20.2559 18.5633 20.0342 19.0895 19.6257C19.6157 19.2173 19.991 18.6453 20.1562 18H21.75C22.1478 18 22.5294 17.842 22.8107 17.5607C23.092 17.2794 23.25 16.8978 23.25 16.5V10.5C23.2501 10.4037 23.232 10.3083 23.1966 10.2188ZM6.75 18.75C6.45333 18.75 6.16332 18.662 5.91665 18.4972C5.66997 18.3324 5.47771 18.0981 5.36418 17.824C5.25065 17.5499 5.22094 17.2483 5.27882 16.9574C5.3367 16.6664 5.47956 16.3991 5.68934 16.1893C5.89912 15.9796 6.16639 15.8367 6.45736 15.7788C6.74834 15.7209 7.04994 15.7506 7.32403 15.8642C7.59811 15.9777 7.83238 16.17 7.9972 16.4166C8.16203 16.6633 8.25 16.9533 8.25 17.25C8.25 17.6478 8.09196 18.0294 7.81066 18.3107C7.52936 18.592 7.14782 18.75 6.75 18.75ZM2.25 12V6H15.75V12H2.25ZM17.25 18.75C16.9533 18.75 16.6633 18.662 16.4166 18.4972C16.17 18.3324 15.9777 18.0981 15.8642 17.824C15.7506 17.5499 15.7209 17.2483 15.7788 16.9574C15.8367 16.6664 15.9796 16.3991 16.1893 16.1893C16.3991 15.9796 16.6664 15.8367 16.9574 15.7788C17.2483 15.7209 17.5499 15.7506 17.824 15.8642C18.0981 15.9777 18.3324 16.17 18.4972 16.4166C18.662 16.6633 18.75 16.9533 18.75 17.25C18.75 17.6478 18.592 18.0294 18.3107 18.3107C18.0294 18.592 17.6478 18.75 17.25 18.75ZM17.25 9.75V7.5H20.4919L21.3919 9.75H17.25Z"
                                  fill="#F7323F"
                                />
                              </svg>
                              <div className={`${styles.lableRed} label1`}>
                                {priceItem.location}
                              </div>
                            </>
                          ) : (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M11.2506 22.5007L8.25061 22.5007C8.0517 22.5007 7.86093 22.4217 7.72028 22.2811C7.57963 22.1404 7.50061 21.9496 7.50061 21.7507C7.5005 21.7013 7.50552 21.652 7.51561 21.6035L8.90686 14.6257L6.68217 14.6257L5.02748 16.2814C4.88763 16.4211 4.69828 16.4999 4.50061 16.5007L2.25061 16.5007C2.12769 16.5009 2.0066 16.4709 1.898 16.4134C1.7894 16.3558 1.69661 16.2724 1.62781 16.1705C1.55901 16.0687 1.51629 15.9515 1.50343 15.8292C1.49057 15.707 1.50795 15.5834 1.55405 15.4695L2.94249 12.0007L1.55405 8.53198C1.50795 8.41803 1.49057 8.2945 1.50343 8.17225C1.51629 8.05 1.55901 7.93279 1.62781 7.83093C1.69661 7.72907 1.7894 7.64568 1.898 7.5881C2.0066 7.53052 2.12769 7.50052 2.25061 7.50073L4.50061 7.50073C4.59913 7.50065 4.6967 7.51999 4.78775 7.55763C4.8788 7.59527 4.96153 7.65048 5.03123 7.72011L6.68592 9.37573L8.90686 9.37573L7.51561 2.39792C7.50552 2.34951 7.5005 2.30018 7.50061 2.25073C7.50061 2.05182 7.57963 1.86105 7.72028 1.7204C7.86093 1.57975 8.0517 1.50073 8.25061 1.50073L11.2506 1.50073C11.3899 1.50063 11.5266 1.53935 11.6451 1.61254C11.7637 1.68573 11.8595 1.7905 11.9219 1.91511L15.6512 9.37573L19.8756 9.37573C20.5718 9.37573 21.2395 9.65229 21.7318 10.1446C22.224 10.6369 22.5006 11.3045 22.5006 12.0007C22.5006 12.6969 22.224 13.3646 21.7318 13.8569C21.2395 14.3492 20.5718 14.6257 19.8756 14.6257L15.6512 14.6257L11.9219 22.0864C11.8595 22.211 11.7637 22.3157 11.6451 22.3889C11.5266 22.4621 11.3899 22.5008 11.2506 22.5007Z"
                                  fill="#69A2FF"
                                />
                              </svg>
                              <div className={`${styles.lableBlue} label1`}>
                                해외
                              </div>
                            </>
                          )}
                        </div>
                        <div className={styles.labelDeliveryTablet}>
                          {priceItem.location === "국내" ? (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M23.1966 10.2188L21.8841 6.9375C21.7727 6.65973 21.5804 6.42184 21.3321 6.25467C21.0839 6.08751 20.7912 5.99878 20.4919 6H17.25V5.25C17.25 5.05109 17.171 4.86032 17.0303 4.71967C16.8897 4.57902 16.6989 4.5 16.5 4.5H2.25C1.85218 4.5 1.47064 4.65804 1.18934 4.93934C0.908035 5.22064 0.75 5.60218 0.75 6V16.5C0.75 16.8978 0.908035 17.2794 1.18934 17.5607C1.47064 17.842 1.85218 18 2.25 18H3.84375C4.00898 18.6453 4.38428 19.2173 4.91048 19.6257C5.43669 20.0342 6.08387 20.2559 6.75 20.2559C7.41613 20.2559 8.06331 20.0342 8.58952 19.6257C9.11572 19.2173 9.49102 18.6453 9.65625 18H14.3438C14.509 18.6453 14.8843 19.2173 15.4105 19.6257C15.9367 20.0342 16.5839 20.2559 17.25 20.2559C17.9161 20.2559 18.5633 20.0342 19.0895 19.6257C19.6157 19.2173 19.991 18.6453 20.1562 18H21.75C22.1478 18 22.5294 17.842 22.8107 17.5607C23.092 17.2794 23.25 16.8978 23.25 16.5V10.5C23.2501 10.4037 23.232 10.3083 23.1966 10.2188ZM6.75 18.75C6.45333 18.75 6.16332 18.662 5.91665 18.4972C5.66997 18.3324 5.47771 18.0981 5.36418 17.824C5.25065 17.5499 5.22094 17.2483 5.27882 16.9574C5.3367 16.6664 5.47956 16.3991 5.68934 16.1893C5.89912 15.9796 6.16639 15.8367 6.45736 15.7788C6.74834 15.7209 7.04994 15.7506 7.32403 15.8642C7.59811 15.9777 7.83238 16.17 7.9972 16.4166C8.16203 16.6633 8.25 16.9533 8.25 17.25C8.25 17.6478 8.09196 18.0294 7.81066 18.3107C7.52936 18.592 7.14782 18.75 6.75 18.75ZM2.25 12V6H15.75V12H2.25ZM17.25 18.75C16.9533 18.75 16.6633 18.662 16.4166 18.4972C16.17 18.3324 15.9777 18.0981 15.8642 17.824C15.7506 17.5499 15.7209 17.2483 15.7788 16.9574C15.8367 16.6664 15.9796 16.3991 16.1893 16.1893C16.3991 15.9796 16.6664 15.8367 16.9574 15.7788C17.2483 15.7209 17.5499 15.7506 17.824 15.8642C18.0981 15.9777 18.3324 16.17 18.4972 16.4166C18.662 16.6633 18.75 16.9533 18.75 17.25C18.75 17.6478 18.592 18.0294 18.3107 18.3107C18.0294 18.592 17.6478 18.75 17.25 18.75ZM17.25 9.75V7.5H20.4919L21.3919 9.75H17.25Z"
                                  fill="#B6BCC9"
                                />
                              </svg>
                            </>
                          ) : (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M11.251 22.5006L8.25098 22.5006C8.05206 22.5006 7.8613 22.4216 7.72064 22.2809C7.57999 22.1403 7.50098 21.9495 7.50098 21.7506C7.50086 21.7012 7.50589 21.6518 7.51598 21.6034L8.90723 14.6256L6.68254 14.6256L5.02785 16.2812C4.888 16.4209 4.69865 16.4998 4.50098 16.5006L2.25098 16.5006C2.12805 16.5008 2.00697 16.4708 1.89836 16.4132C1.78976 16.3557 1.69698 16.2723 1.62818 16.1704C1.55937 16.0685 1.51666 15.9513 1.5038 15.8291C1.49094 15.7068 1.50832 15.5833 1.55441 15.4694L2.94285 12.0006L1.55441 8.53186C1.50832 8.41791 1.49094 8.29437 1.5038 8.17213C1.51666 8.04988 1.55937 7.93267 1.62818 7.83081C1.69698 7.72895 1.78976 7.64556 1.89836 7.58798C2.00697 7.5304 2.12806 7.5004 2.25098 7.50061L4.50098 7.50061C4.5995 7.50053 4.69707 7.51987 4.78811 7.55751C4.87916 7.59515 4.9619 7.65036 5.0316 7.71998L6.68629 9.37561L8.90723 9.37561L7.51598 2.3978C7.50589 2.34939 7.50086 2.30006 7.50098 2.25061C7.50098 2.0517 7.57999 1.86093 7.72065 1.72028C7.8613 1.57963 8.05206 1.50061 8.25098 1.50061L11.251 1.50061C11.3903 1.50051 11.5269 1.53923 11.6455 1.61242C11.764 1.68561 11.8599 1.79038 11.9222 1.91499L15.6516 9.37561L19.876 9.37561C20.5722 9.37561 21.2398 9.65217 21.7321 10.1445C22.2244 10.6367 22.501 11.3044 22.501 12.0006C22.501 12.6968 22.2244 13.3645 21.7321 13.8568C21.2398 14.349 20.5722 14.6256 19.876 14.6256L15.6516 14.6256L11.9222 22.0862C11.8599 22.2108 11.764 22.3156 11.6455 22.3888C11.5269 22.462 11.3903 22.5007 11.251 22.5006Z"
                                  fill="#B6BCC9"
                                />
                              </svg>
                            </>
                          )}
                        </div>
                        <div className={`${styles.deliveryText} body4`}>
                          배송기간
                        </div>
                        <div className={styles.deliveryPeriod}>
                          <div className={`${styles.body1Tablet} caption1`}>
                            {periodFigma(priceItem)}
                          </div>
                          <div className={`${styles.body1Tablet} caption2`}>
                            일
                          </div>
                        </div>
                        <div className={styles.deliveryPeriodTablet}>
                          <div className={`${styles.body1Tablet} caption1`}>
                            {periodFigma(priceItem)}
                          </div>
                          <div className={`${styles.body1Tablet} caption2`}>
                            일
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.purchaseButtonPC}>
                      <GotoFigma
                        pics={priceItem}
                        data={part}
                        isLoginCheck={isLogin}
                        keyword={keyword}
                      />
                    </div>
                    <div className={styles.purchaseButtonMo}>
                      <Goto
                        pics={priceItem}
                        data={part}
                        isLoginCheck={isLogin}
                        keyword={keyword}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.productDetailPriceDeliveryGroupTablet}>
                  <div className={styles.searchThReBoReRi_PriceInfo}>
                    <div className={styles.searchThReBoReRiTo_ItemInfo}>
                      <div className={styles.searchThReBoReRiToTo_PriceInfo}>
                        {/* 맞춤단가 특가제공 */}
                        <div className={styles.searchThReBoReRiToToFi_FitPrice}>
                          <div>맞춤 단가</div>
                        </div>
                        {priceItem.source === "partner" ? (
                          <div className={styles.specialPrice}>
                            <div className={`${styles.label2} label2`}>
                              특가제공
                            </div>
                          </div>
                        ) : // 상시할인이 들어가는 회원은 회원혜택가 노출
                        member > 1 || isLogin == 0 ? (
                          <div className={styles.memberPrice}>
                            <div className={`${styles.label2} label2`}>
                              회원혜택가
                            </div>
                          </div>
                        ) : (
                          // 상시할인이 들어가지 않으면 회원(일반회원,비회원)은 일반회원가 노출
                          <div className={styles.normalPrice}>
                            <div className={`${styles.label2} label2`}>
                              일반회원가
                            </div>
                          </div>
                        )}
                      </div>
                      {/* 배송정보 Info */}
                      <div className={styles.searchThReBoReRiToBo_DeliveryInfo}>
                        <div
                          className={styles.searchThReBoReRiToBoFi_DeliveryDate}
                        >
                          {priceItem.location === "국내" ? (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M23.1966 10.2188L21.8841 6.9375C21.7727 6.65973 21.5804 6.42184 21.3321 6.25467C21.0839 6.08751 20.7912 5.99878 20.4919 6H17.25V5.25C17.25 5.05109 17.171 4.86032 17.0303 4.71967C16.8897 4.57902 16.6989 4.5 16.5 4.5H2.25C1.85218 4.5 1.47064 4.65804 1.18934 4.93934C0.908035 5.22064 0.75 5.60218 0.75 6V16.5C0.75 16.8978 0.908035 17.2794 1.18934 17.5607C1.47064 17.842 1.85218 18 2.25 18H3.84375C4.00898 18.6453 4.38428 19.2173 4.91048 19.6257C5.43669 20.0342 6.08387 20.2559 6.75 20.2559C7.41613 20.2559 8.06331 20.0342 8.58952 19.6257C9.11572 19.2173 9.49102 18.6453 9.65625 18H14.3438C14.509 18.6453 14.8843 19.2173 15.4105 19.6257C15.9367 20.0342 16.5839 20.2559 17.25 20.2559C17.9161 20.2559 18.5633 20.0342 19.0895 19.6257C19.6157 19.2173 19.991 18.6453 20.1562 18H21.75C22.1478 18 22.5294 17.842 22.8107 17.5607C23.092 17.2794 23.25 16.8978 23.25 16.5V10.5C23.2501 10.4037 23.232 10.3083 23.1966 10.2188ZM6.75 18.75C6.45333 18.75 6.16332 18.662 5.91665 18.4972C5.66997 18.3324 5.47771 18.0981 5.36418 17.824C5.25065 17.5499 5.22094 17.2483 5.27882 16.9574C5.3367 16.6664 5.47956 16.3991 5.68934 16.1893C5.89912 15.9796 6.16639 15.8367 6.45736 15.7788C6.74834 15.7209 7.04994 15.7506 7.32403 15.8642C7.59811 15.9777 7.83238 16.17 7.9972 16.4166C8.16203 16.6633 8.25 16.9533 8.25 17.25C8.25 17.6478 8.09196 18.0294 7.81066 18.3107C7.52936 18.592 7.14782 18.75 6.75 18.75ZM2.25 12V6H15.75V12H2.25ZM17.25 18.75C16.9533 18.75 16.6633 18.662 16.4166 18.4972C16.17 18.3324 15.9777 18.0981 15.8642 17.824C15.7506 17.5499 15.7209 17.2483 15.7788 16.9574C15.8367 16.6664 15.9796 16.3991 16.1893 16.1893C16.3991 15.9796 16.6664 15.8367 16.9574 15.7788C17.2483 15.7209 17.5499 15.7506 17.824 15.8642C18.0981 15.9777 18.3324 16.17 18.4972 16.4166C18.662 16.6633 18.75 16.9533 18.75 17.25C18.75 17.6478 18.592 18.0294 18.3107 18.3107C18.0294 18.592 17.6478 18.75 17.25 18.75ZM17.25 9.75V7.5H20.4919L21.3919 9.75H17.25Z"
                                  fill="#B6BCC9"
                                />
                              </svg>
                            </>
                          ) : (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M11.251 22.5006L8.25098 22.5006C8.05206 22.5006 7.8613 22.4216 7.72064 22.2809C7.57999 22.1403 7.50098 21.9495 7.50098 21.7506C7.50086 21.7012 7.50589 21.6518 7.51598 21.6034L8.90723 14.6256L6.68254 14.6256L5.02785 16.2812C4.888 16.4209 4.69865 16.4998 4.50098 16.5006L2.25098 16.5006C2.12805 16.5008 2.00697 16.4708 1.89836 16.4132C1.78976 16.3557 1.69698 16.2723 1.62818 16.1704C1.55937 16.0685 1.51666 15.9513 1.5038 15.8291C1.49094 15.7068 1.50832 15.5833 1.55441 15.4694L2.94285 12.0006L1.55441 8.53186C1.50832 8.41791 1.49094 8.29437 1.5038 8.17213C1.51666 8.04988 1.55937 7.93267 1.62818 7.83081C1.69698 7.72895 1.78976 7.64556 1.89836 7.58798C2.00697 7.5304 2.12806 7.5004 2.25098 7.50061L4.50098 7.50061C4.5995 7.50053 4.69707 7.51987 4.78811 7.55751C4.87916 7.59515 4.9619 7.65036 5.0316 7.71998L6.68629 9.37561L8.90723 9.37561L7.51598 2.3978C7.50589 2.34939 7.50086 2.30006 7.50098 2.25061C7.50098 2.0517 7.57999 1.86093 7.72065 1.72028C7.8613 1.57963 8.05206 1.50061 8.25098 1.50061L11.251 1.50061C11.3903 1.50051 11.5269 1.53923 11.6455 1.61242C11.764 1.68561 11.8599 1.79038 11.9222 1.91499L15.6516 9.37561L19.876 9.37561C20.5722 9.37561 21.2398 9.65217 21.7321 10.1445C22.2244 10.6367 22.501 11.3044 22.501 12.0006C22.501 12.6968 22.2244 13.3645 21.7321 13.8568C21.2398 14.349 20.5722 14.6256 19.876 14.6256L15.6516 14.6256L11.9222 22.0862C11.8599 22.2108 11.764 22.3156 11.6455 22.3888C11.5269 22.462 11.3903 22.5007 11.251 22.5006Z"
                                  fill="#B6BCC9"
                                />
                              </svg>
                            </>
                          )}

                          <div className={`${styles.body1Tablet} caption1`}>
                            {periodNoDiv(priceItem)}
                          </div>
                          <div className={`${styles.body1Tablet} caption2`}>
                            일
                          </div>
                        </div>
                        <div className={styles.line7}></div>
                        <div className={styles.searchThReBoReRiToBoTh_Text}>
                          {priceItem.packaging || "-"}
                        </div>
                      </div>
                    </div>
                    <div className={styles.searchThReBoReRiBo_ButtonGroup}>
                      <Goto
                        pics={priceItem}
                        data={part}
                        isLoginCheck={isLogin}
                        keyword={keyword}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
